import React, { useState, useEffect } from 'react';
import { FaHeadset, FaEnvelope, FaWhatsapp, FaLinkedin, FaFacebookF, FaTwitter, FaTelegram } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';

const TechnicalSupport = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
    } else {
      const timer = setTimeout(() => setIsVisible(false), 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  const togglePopup = () => setIsOpen(!isOpen);

  const shareMessage = "Découvrez EasySyntaxe, l'outil ultime pour trouver rapidement les syntaxes de vos opérateurs mobiles ! Essayez-le maintenant : https://easysyntaxe.vercel.app";

  const shareLinks = [
    { name: 'LinkedIn', icon: FaLinkedin, url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent('https://easysyntaxe.vercel.app')}&summary=${encodeURIComponent(shareMessage)}`, color: 'bg-blue-100 text-blue-600' },
    { name: 'Facebook', icon: FaFacebookF, url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent('https://easysyntaxe.vercel.app')}&quote=${encodeURIComponent(shareMessage)}`, color: 'bg-blue-100 text-blue-600' },
    { name: 'Twitter', icon: FaTwitter, url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareMessage)}`, color: 'bg-blue-100 text-blue-400' },
    { name: 'WhatsApp', icon: FaWhatsapp, url: `https://wa.me/?text=${encodeURIComponent(shareMessage)}`, color: 'bg-green-100 text-green-600' },
    { name: 'Telegram', icon: FaTelegram, url: `https://t.me/share/url?url=${encodeURIComponent('https://easysyntaxe.vercel.app')}&text=${encodeURIComponent(shareMessage)}`, color: 'bg-blue-100 text-blue-500' },
  ];

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <button
        onClick={togglePopup}
        className="bg-black text-white rounded-full p-4 shadow-lg hover:bg-gray-800 transition-colors duration-300"
      >
        <FaHeadset size={24} />
      </button>

      <AnimatePresence>
        {isVisible && (
          <motion.div 
            className="absolute bottom-16 right-0 w-80 bg-white rounded-lg shadow-xl p-4"
            initial={{ opacity: 0, y: 20 }} // Position initiale
            animate={{ opacity: 1, y: 0 }} // Animation d'apparition
            exit={{ opacity: 0, y: 20 }} // Animation de disparition
            transition={{ duration: 0.3 }} // Durée de l'animation
          >
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Support Technique</h3>
              <button onClick={togglePopup} className="text-gray-500 hover:text-gray-800">
                &times;
              </button>
            </div>
            <p className="text-sm text-gray-600 mb-4">
              Besoin d'aide ? Contactez-nous via l'un des moyens ci-dessous !
            </p>
            
            <div className="space-y-2 mb-4">
              <a href="mailto:hello@princekouame.com" className="flex items-center text-blue-600 hover:text-blue-800 bg-blue-100 bg-opacity-50 rounded-md px-3 py-2 transition-colors duration-200">
                <FaEnvelope className="mr-2" /> Message via Email
              </a>
              <a href="https://wa.me/2250709745385" className="flex items-center text-green-600 hover:text-green-800 bg-green-100 bg-opacity-50 rounded-md px-3 py-2 transition-colors duration-200">
                <FaWhatsapp className="mr-2" /> Message via WhatsApp
              </a>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-2">Partager EasySyntaxe</h4>
              <div className="flex space-x-2">
                {shareLinks.map((link, index) => (
                  <a
                    key={index}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${link.color} p-2 rounded-md hover:opacity-80 transition-opacity duration-200`}
                  >
                    <link.icon size={16} />
                  </a>
                ))}
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default TechnicalSupport;